'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global window */

var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

var isNode = typeof module !== 'undefined' && typeof module.exports !== 'undefined';

exports.isBrowser = isBrowser;
exports.isNode = isNode;


//////////////////
// WEBPACK FOOTER
// ./~/browser-or-node/lib/index.js
// module id = 666
// module chunks = 114276838955818